import Share from 'ninelines-sharing';

function init() {
	$('[data-social]').on('click.share', (e) => {
		const $socialBtn = $(e.currentTarget);
		const social = $socialBtn.data('social');
		let url = location.origin + location.pathname + location.search;

		$socialBtn.get(0).blur();

		Share[social](url);
	});
}

function destroy() {
	$('[data-social]').off('.share');
}

export default {
	init,
	destroy,
};
